/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Routes } from '@administration-client/shared';
import { UserService } from '@administration-client/user-shared';
import { NavigationService } from '@alfa-client/navigation-shared';
import { createEmptyStateResource, isNotLoading, StateResource } from '@common/tech-shared';
import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { UserFormService } from '../user.formservice';
import { UserDeleteDialogComponent } from './user-delete-dialog/user-delete-dialog.component';

@Component({
  selector: 'administration-delete-dialog-container',
  imports: [UserDeleteDialogComponent, AsyncPipe],
  templateUrl: './user-delete-dialog-container.component.html',
})
export class UserDeleteDialogContainerComponent {
  public readonly formService = inject(UserFormService);
  public readonly userService = inject(UserService);
  public readonly navigationService = inject(NavigationService);

  public deleteUserStateResource$: Observable<StateResource<unknown>> = of(createEmptyStateResource());

  public deleteUser(): void {
    this.deleteUserStateResource$ = this.userService
      .delete(this.formService.getId())
      .pipe(tap((state: StateResource<unknown>) => this.navigateOnDeleteSuccess(state)));
  }

  private navigateOnDeleteSuccess(state: StateResource<any>): void {
    if (isNotLoading(state)) {
      this.navigationService.navigate(Routes.BENUTZER);
    }
  }
}
